module.exports = __webpack_public_path__ + "static/media/btc.edae64fc.svg";